const o = {
  name: "Poland",
  dimensions: { width: 25, height: 25 },
  content: `
    <g>
      <path d="M13.98 20.0875H13.88C12.78 20.6875 11.28 20.6875 10.08 20.0875H9.97998C9.17998 20.0875 8.97998 21.2875 8.97998 22.0875C8.97998 22.8875 9.37998 23.0875 11.98 23.0875C14.58 23.0875 14.98 22.8875 14.98 22.0875C14.98 21.2875 14.78 20.0875 13.98 20.0875Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16.98 12.0875L14.98 22.2875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16.98 12.0875C16.98 12.0875 17.98 9.08752 19.98 9.08752C21.98 9.08752 22.98 6.08752 22.98 6.08752C23.98 3.08752 21.98 1.08752 21.98 1.08752C22.98 3.08752 20.98 6.08752 18.98 6.08752H17.98C11.98 4.08752 5.98 6.08752 5.98 6.08752H5.28C3.28 6.08752 1.28 3.08752 2.28 1.08752C2.28 1.08752 0.28 3.08752 1.28 6.08752C1.28 6.08752 2.28 9.08752 4.28 9.08752C6.28 9.08752 6.98 12.0875 6.98 12.0875L8.98 22.2875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Poland
};
